export function smoothScroll(elementSelector, direction, duration) {
	const element = document.querySelector(elementSelector)
	const startingY = element.scrollTop
	const targetY = direction === 'top' ? 0 : element.scrollHeight - element.clientHeight
	const diff = targetY - startingY

	// If duration is 0, jump immediately to the position
	if (duration === 0) {
		element.scrollTop = targetY
		return
	}

	let start
	function step(timestamp) {
		if (!start) start = timestamp
		const progress = Math.min((timestamp - start) / duration, 1)
		const ease = progress < 0.5 ? 2 * progress * progress : (4 - 2 * progress) * progress - 1
		element.scrollTop = startingY + diff * ease
		if (progress < 1) window.requestAnimationFrame(step)
	}
	window.requestAnimationFrame(step)
}
